export default __webpack_public_path__ + "static/media/2.cfee3be8.svg";